'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ISOFieldPackager2 = require('./ISOFieldPackager');

var _ISOFieldPackager3 = _interopRequireDefault(_ISOFieldPackager2);

var _Padder = require('../Padder');

var _Padder2 = _interopRequireDefault(_Padder);

var _Interpreter = require('../Interpreter');

var _Interpreter2 = _interopRequireDefault(_Interpreter);

var _Prefixer = require('../Prefixer');

var _Prefixer2 = _interopRequireDefault(_Prefixer);

var _ISOComponent = require('../ISOComponent');

var _ISOComponent2 = _interopRequireDefault(_ISOComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Bruno bruno.camargos@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2016/01/18
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ISOAmountFieldPackager = function (_ISOFieldPackager) {
    _inherits(ISOAmountFieldPackager, _ISOFieldPackager);

    function ISOAmountFieldPackager(maxLength, description, padder, interpreter, prefixer) {
        _classCallCheck(this, ISOAmountFieldPackager);

        var _this = _possibleConstructorReturn(this, (ISOAmountFieldPackager.__proto__ || Object.getPrototypeOf(ISOAmountFieldPackager)).call(this, maxLength, description));

        _this.interpreter = interpreter;
        _this.padder = padder;
        _this.prefixer = prefixer;
        return _this;
    }

    /**
     * Sets the Padder.
     * @param padder The padder to use during packing and unpacking.
     */


    _createClass(ISOAmountFieldPackager, [{
        key: 'setPadder',
        value: function setPadder(padder) {
            this.padder = padder;
        }

        /**
         * Sets the Interpreter.
         * @param interpreter The interpreter to use in packing and unpacking.
         */

    }, {
        key: 'setInterpreter',
        value: function setInterpreter(interpreter) {
            this.interpreter = interpreter;
        }
    }, {
        key: 'setPrefixer',
        value: function setPrefixer(prefixer) {
            this.prefixer = prefixer;
        }
    }, {
        key: 'checkLength',
        value: function checkLength(len, maxLength) {
            if (len > maxLength) {
                throw Error('Length ' + len + ' too long for ' + this.name);
            }
        }

        /**
         * Returns the prefixer's packed length and the interpreter's packed length.
         */

    }, {
        key: 'getMaxPackedLength',
        value: function getMaxPackedLength() {
            return this.prefixer.getPackedLength() + this.interpreter.getPackedLength(this.getLength());
        }
    }, {
        key: 'pack',
        value: function pack(field) {
            var data = field.getValue();
            if (data.length > this.getLength()) {
                throw Error('Field length ' + data.length + ' too long. Max: ' + this.getLength());
            }

            var sign = data.substring(0, 1);
            var amount = data.substring(1);

            var paddedData = this.padder.pad(amount, this.getLength() - 1);
            var signLength = this.interpreter.getPackedLength(1);

            var len = this.prefixer.getPackedLength() + this.interpreter.getPackedLength(paddedData.length);

            var rawData = new Array(this.prefixer.getPackedLength() + signLength + this.interpreter.getPackedLength(paddedData.length));

            this.prefixer.encodeLength(paddedData.length, rawData);

            this.interpreter.interpret(sign, rawData, this.prefixer.getPackedLength());
            this.interpreter.interpret(paddedData, rawData, this.prefixer.getPackedLength() + signLength);

            return rawData;
        }
    }, {
        key: 'unpack',
        value: function unpack(field, b, offset) {
            var len = this.prefixer.decodeLength(b, offset);
            if (len === -1) {
                // The prefixer doesn't know how long the field is, so use
                // maxLength instead
                len = this.getLength();
            } else if (this.getLength() > 0 && len > this.getLength()) {
                throw Error('Field length ' + len + ' too long. Max: ' + this.getLength());
            }

            var lenLen = this.prefixer.getPackedLength();
            var unpacked = this.interpreter.uninterpret(b, offset + lenLen, len);
            field.setValue(unpacked);
            return lenLen + this.interpreter.getPackedLength(len);
        }
    }]);

    return ISOAmountFieldPackager;
}(_ISOFieldPackager3.default);

exports.default = ISOAmountFieldPackager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/packer/ISOAmountFieldPackager.js
// module id = 42
// module chunks = 0